import { render, staticRenderFns } from "./NonResidentTravelBuyCover.vue?vue&type=template&id=92488908&scoped=true"
import script from "./NonResidentTravelBuyCover.vue?vue&type=script&lang=js"
export * from "./NonResidentTravelBuyCover.vue?vue&type=script&lang=js"
import style0 from "./NonResidentTravelBuyCover.vue?vue&type=style&index=0&id=92488908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92488908",
  null
  
)

export default component.exports